<template>
  <div id="app-content">
    <header v-if="!$route.meta.inGame && !$route.meta.standalone" class="main-nav">
      <div class="logo">
        <img src="/logo.png" alt="Stonebound logo" />
      </div>
      <div class="nav-container">
        <nav class="nav-links">
          <RouterLink to="/">Home</RouterLink>
          <RouterLink to="/login">Play</RouterLink>
        </nav>
      </div>
      <div class="logo">
        <img src="/logo2.png" alt="Stonebound logo" />
      </div>
    </header>
    <main v-if="!$route.meta.standalone" class="container">
      <RouterView />
    </main>
    <RouterView v-else />
    <footer v-if="!$route.meta.inGame && !$route.meta.standalone" class="footer">
      <p>version: alpha-preview {{version}} 2025-10</p>
    </footer>
  </div>
</template>

<script setup>
  const version = __APP_VERSION__
</script> 

<style>
@import url("https://fonts.googleapis.com/css2?family=IM+Fell+DW+Pica+SC&display=swap");

html,
body {
  height: 100%;
  margin: 0;
  color: #e0c097; 
  background-color: #2e2b22; /* Darker background for a prehistoric feel */
  font-family: "IM Fell DW Pica SC", serif; /* Prehistoric looking font */
}
 button {
  font-family: "IM Fell DW Pica SC", serif;
 }

#app-content {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-size: 1.3em; 
  width: 100vw; 
  align-items: center; /* Center the content horizontally */
}

header.main-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #222;
  padding: 10px;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1000; /* Ensure it stays above other content */
}

header.main-nav .logo {
  display: flex;
  align-items: center;
}

header.main-nav .logo img {
  width: 150px;
  height: 100px;
  margin: 0 10px;
}

header.main-nav .nav-links a {
  margin: 0 10px;
  padding: 5px 10px;
  text-decoration: none;
  color: white; /* Set inactive links to white */
}

header.main-nav .nav-links a.router-link-active {
  color: rgb(192, 189, 38);
  background-color: #424f36;
}

main.container {
  flex: 1; /* Make the main content area take up the remaining space */
  max-width: 800px;
  margin: 0 auto;
  padding: 20px; /* Added padding for better spacing */
}

footer.footer {
  background-color: #222;
  color: #e0c097; /* Adjusted color to match h1 */
  /* text-align: center; */
  padding: 10px;
  position: sticky;
  bottom: 0;
  width: 100%; /* Ensure the footer takes the full width of the viewport */
}

h1 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 2.5em; 
  color: #e0c097; /* Lighter color for the title */
}
p {
  margin-bottom: 15px;
}
</style>
